<script>
import Navbar from "@/view/front/components/navbar";
import Switcher from "@/view/front/components/switcher";
import Footer from "@/view/front/components/footer";
import axios from "axios";
import { API_URL, MEDIA_URL } from "@/core/api";
// import Skeleton from "@/view/front/components/skeleton";
import moment from "moment";
import Swal from "sweetalert2";
import Multiselect from "vue-multiselect";
import IndexService from "@/MainServices/IndexService.js";

/**
 * page-jobs-new component
 */
export default {
  metaInfo: function() {
    return {
      title: "Cover letter advice - Find Your Dream Job - job4u.pk",
      meta: [
      { name: 'description', content:  "A cover letter is as important now as it was 20 years ago, if not more so." }
      ]
    }
  },
  data() {
    return {
      auth: localStorage.getItem("id_token") !== null ? true : false,
      token: `Bearer ${localStorage.getItem("token")}`,
      user:
        localStorage.getItem("user") !== null
          ? JSON.parse(localStorage.getItem("user"))
          : {},
      profile:
        localStorage.getItem("profile") !== null
          ? JSON.parse(localStorage.getItem("profile"))
          : {},
      loading: true,
      mediaUrl: MEDIA_URL,
      apiUrl: API_URL,
      keywords: "",
      email: "",
      locations: [],
      selected_cities: [],
      cities: [],
      data: [],
      experiences: [],
      selected_job_experience: [],
      success: false,
    };
  },
  components: {
    Navbar,
    Multiselect,
    Switcher,
    // Skeleton,
    Footer,
  },
  mounted() {var link = !!document.querySelector("link[rel='canonical']") ? document.querySelector("link[rel='canonical']") : document.createElement('link');
    link.setAttribute('rel', 'canonical');
    link.setAttribute('href', location.protocol + '//' + location.host + location.pathname);
    document.head.appendChild(link);
    IndexService.getCities().then((res) => {
      res.data.map((el) => {
        this.cities.push({
          id: el.id,
          value: el.city_name,
        });
      });
    });
    this.email = this.auth ? this.user.email : "";
    this.location = this.auth ? this.profile.city : "";
    this.getJobCareerLevel();
  },
  methods: {
    moment: function (date) {
      return moment(date);
    },
    getJobCareerLevel() {
      this.loading = true;
      axios.get(`${this.apiUrl}/get-job-career-levels`).then((response) => {
        this.experiences = response.data;
      });
    },
    submitJobAlert() {
      this.selected_cities.map((el) => {
        this.locations.push(el.value,);
      });
      this.success = true;
      if (!this.keywords) {
        Swal.fire({
          title: "",
          text: "Please enter keyword!",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false,
        });
        this.success = false;
        return;
      }
      if (
        !this.selected_job_experience ||
        this.selected_job_experience == null ||
        this.selected_job_experience == ""
      ) {
        Swal.fire({
          title: "",
          text: "Please select job experience!",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false,
        });
        this.success = false;
        return;
      }
      if (!this.location) {
        Swal.fire({
          title: "",
          text: "Please select job location!",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false,
        });
        this.success = false;
        return;
      }
      axios
        .post(`${API_URL}/job-alert`, {
          keywords: this.keywords,
          location: this.locations,
          career_level: this.selected_job_experience,
          email: this.email,
        })
        .then((res) => {
          this.success = true;
          setTimeout(() => {
            this.success = false;
          }, 3000);
          if (res.data === "200") {
            Swal.fire({
              title: "",
              text: "Job alert has been saved.",
              icon: "success",
              confirmButtonClass: "btn btn-secondary",
              heightAuto: false,
            });
            this.success = false;
          } else {
            Swal.fire({
              title: "",
              text: "Some thing went rong",
              icon: "error",
              confirmButtonClass: "btn btn-secondary",
              heightAuto: false,
            });
            this.success = false;
          }
        });
    },
    _jobCareerSelection(event) {
      if (event.target.checked) {
        if (!this.selected_job_experience.includes(event.target.value)) {
          var temp = this.selected_job_experience;
          temp.push(event.target.value);
          this.selected_job_experience = temp;
        }
      } else {
        var temp = [];
        this.selected_job_experience.forEach((element) => {
          if (element !== event.target.value) {
            temp.push(event.target.value);
          }
        });
        this.selected_job_experience = temp;
      }
    },
  },
};
</script>

<template>
  <div>
    <Navbar />

    <!-- Hero Start -->
    <section class="section_ch_p bg-light d-table w-100 mt-10">
      <div class="container">
        <div class="row">
          <div class="col-lg-8 col-md-8 pagech1">
            <div class="blog_header pl-0">
              <div class="col-lg-12 p-0 w-100">
                <div class="blog_back">
                  <i class="fas fa-long-arrow-alt-left p-1"></i>
                  <router-link to="/career-resources"
                    >Back to blog list</router-link
                  >
                </div>
              </div>
              <h2 class="m_title">Cover Letter Advice</h2>
              <span class="m_title">by: job4u.pk (3 min read)</span>
            </div>

            <div class="p_about2">
              A cover letter is as important now as it was 20 years ago, if not
              more so. Your cover letter is your personalized introduction to a
              company, and an opportunity to make a great first impression on a
              prospective employer. It showcases more of your unique
              personality, and is a way to stand out as an individual, not just
              an applicant, so putting effort into it pays off.
            </div>

            <div class="p_about2">
              The most important tip for cover letters is, inarguably, that your
              cover letter should not be a regurgitation or a paraphrasing of
              your CV. Essentially, a cover letter should draw attention to
              specific skills and experience that make you an ideal candidate,
              as well as highlighting other relevant skills not mentioned in
              your CV. Don’t simply list these; talk about them in a few
              sentences, because this gives you the opportunity to ‘humanize’
              and describe yourself further, which can give you the edge over
              other applicants.
            </div>

            <div class="p_about2">
              Your cover letter should be tailored to each job you apply for,
              because only a letter that’s targeted to the job at hand will make
              a positive impression. Your employers are as bored of seeing
              generic cover letters as you are of sending them, so putting in
              the few minutes to make your cover letter unique will make an
              impact. Your cover letter can’t be ignored if it ties into the
              elements of the job that match your unique skills and experience.
              Back up these skills and experience with facts and figures, so
              that your skills are quantifiable, and not just vague terms. You
              can also further personalize your cover letter by demonstrating
              your familiarity with the specific industry, employer, and type of
              position.
            </div>

            <div class="p_about2">
              Your cover letter is a rundown of your strengths, so don’t be
              afraid to sound confident! Now, we don’t mean that you should be
              boasting about every small feat, but companies generally want
              confident employees, because these are the people who tend to
              perform better, serve as stronger team members, and have greater
              potential to grow along with the business.
            </div>

            <div class="p_about2">
              Your cover letter should be a page or less, so keep it brief! We
              know, that goes against everything we’ve mentioned so far, but the
              effective cover letter manages to put forward all the important
              points concisely and effectively, while still being brief, punchy,
              and to the point. Try not to waste space on your page with too
              many personal anecdotes, instead utilizing it to mention
              accomplishments or notable skills that would be of value to your
              potential employer.
            </div>

            <div class="p_about2">
              Whenever you finish writing your cover letter, there is one
              critical step to take before you send it off to the hiring
              manager: proofreading. Be sure to read the entire letter over and
              make sure there are no mistyped words, grammatical inaccuracies,
              incomplete sentences, or other errors. If you’re unsure, send the
              letter to a friend or family member to proofread after you, so
              that you can be sure you put your best foot forward in front of
              any hiring committee who reads your letter.
            </div>
            <br />
            <!-- <hr> -->
          </div>
          <div class="col-lg-4 col-md-4 mt-3">
            <div class="card">
              <div class="back_overlay">
                <div class="row">
                  <div class="col-lg-6 col-10">
                    <h2 class="">want a great job taillard to your skills ?</h2>
                    <p class="">
                      save time and find higher quality jobs by signing up to
                      job4u.pk
                    </p>
                    <button type="submit" class="btn btn-default join_btn mb-6">
                      <a href="/job-seeker-register">Join job4u.pk now! </a>
                    </button>
                  </div>
                  <div class="col-lg-6 col-2 cv_image_bg">
                    <!-- <img src="/images/carer_resorses/CV.png" alt=""> -->
                  </div>
                </div>
              </div>
            </div>
            <div class="card mt-5">
              <div class="card-headerchch">Create a job alert!</div>
              <div class="card-body p-5">
                <form>
                  <div class="form-group">
                    <label class="labal_style" for="kyeword"
                      >keywords <span style="color: red">*</span></label
                    >
                    <input
                      type="text"
                      v-model="keywords"
                      class="form-control form-control-sm serach_i_ch"
                      id="kyeword"
                      placeholder="Enter Kyewords"
                    />
                  </div>

                  <div class="m_title pt-1 labal_style">
                    CAREER LEVELS <span style="color: red">*</span>
                  </div>
                  <div class="" style="">
                    <ul class="mt-2">
                      <li v-for="(item, index) in experiences" :key="index">
                        <input
                          type="checkbox"
                          :id="item.career_level"
                          :name="item.career_level"
                          class="custom-control-input"
                          :value="item.career_level"
                          v-on:click="_jobCareerSelection($event)"
                        /><label
                          class="custom-control-label"
                          :for="item.career_level"
                          style="font-size: 13px"
                          >{{ item.career_level }}</label
                        >
                      </li>
                    </ul>
                  </div>
                  <div class="form-group">
                    <label class="labal_style" for="exampleInputlocalisation1"
                      >Job Location</label
                    >
                    <div class="col-md-12 form-group m-0 p-0">
                      <multiselect
                        class="selectch home_city_selct"
                        id="multiselectCities"
                        v-model="selected_cities"
                        :height="300"
                        :options="cities"
                        :multiple="true"
                        :close-on-select="false"
                        :clear-on-select="false"
                        :preserve-search="true"
                        placeholder="location you love"
                        label="value"
                        track-by="value"
                        :preselect-first="false"
                      >
                      </multiselect>
                      <img
                        src="images/s_2.svg"
                        width="15"
                        height="15"
                        alt="..."
                        class="icon_search__"
                      />
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="labal_style" for="exampleInputYouremail1"
                      >Your email<span style="color: red">*</span></label
                    >
                    <input
                      type="text"
                      v-model="email"
                      class="form-control form-control-sm serach_i_ch"
                      id="exampleInputYouremail1"
                      placeholder="Youremail"
                    />
                  </div>
                  <div>
                    <button
                      type="button"
                      class="card-headerch_btn bg_blue_ch"
                      @click="submitJobAlert()"
                      :class="
                        success ? 'spinner spinner-light pinner-right' : ''
                      "
                    >
                      Create job alert!
                    </button>
                    <!-- <div
                      v-if="success"
                      class="alert ml-5"
                      style="
                        background-color: #d4edda;
                        border-color: #d4edda;
                        color: #155724;
                      "
                      role="alert"
                    >
                      Form Submited
                    </div> -->
                  </div>
                </form>
              </div>
            </div>
          </div>
          <!--end col-->
        </div>
        <!--end row-->
      </div>
      <!--end container-->
    </section>
    <!--end section-->
    <!-- Hero End -->

    <Footer />
    <!-- Footer End -->
    <Switcher />
    <!-- Back to top -->
    <a
      href="javascript: void(0);"
      class="btn btn-icon btn-soft-primary back-to-top"
      id="back-to-top"
      v-scroll-to="'#topnav'"
    >
      <arrow-up-icon class="icons"></arrow-up-icon>
    </a>
    <!-- Back to top -->
  </div>
</template>
